if(!customElements.get('cre-product-form')) {
  customElements.define(
    'cre-product-form',
    class CreProductForm extends HTMLElement {
      constructor() {
        super();

        this.productType = this.getAttribute('data-product-type')
        this.productForm = this.querySelector('form');
        this.addToCartButton = this.querySelector('.cre-atc-btn');
        this.addToCartSpinner = this.querySelector('.loading-overlay__spinner');
        this.productVariantId = this.getAttribute('data-vid');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartUpdateUnsubscriber = undefined;
        this.sellingPlanSelect = this.querySelector('.selling-plan-options');

        this.bindUIElements();

        console.log('cdebug cre-product-form init...');
      }

      bindUIElements() {
        this.productForm.addEventListener('submit', this.onProductFormSubmit.bind(this))
      }

      toggleElementVisibility(show) {
        if(show) {
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }
      }

      onCartUpdate(e) {
        console.log('cdebug cre-product-form update', e);
        if(e?.source == 'clear-cart') {
          this.toggleElementVisibility(true);
        }

        const incomingVariantId = e?.productVariantId;
        const incomingQty = +e?.incomingQty;

        if(incomingVariantId == this.productVariantId) {
          // Toggle visibility
          if(incomingQty == 0) {
            this.toggleElementVisibility(true);
          } else {
            this.toggleElementVisibility();
          }
        }

      }

      connectedCallback() {
        // Declare subscriber for updates to cart
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        // Declare subscriber for updates to cart
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      pushDataToKlaviyo() {
        try {
          const categories = this?.getAttribute('data-track-categories').split(',') || [];

          const item = {
            "Name": this?.getAttribute('data-track-name'),
            "ProductID": this?.getAttribute('data-track-id'),
            "Categories": categories,
            "ImageURL": this?.getAttribute('data-track-image-url'),
            "URL": this?.getAttribute('data-track-url'),
            "Brand": this?.getAttribute('data-track-brand'),
            "Price": this?.getAttribute('data-track-price'),
            "Value": this?.getAttribute('data-track-value'),
            "CompareAtPrice": this?.getAttribute('data-track-compare-at-price')
          };

          if(_learnq) {
            _learnq.push(['track', 'Added to Cart', item]);
            console.log('cdebug cre-product-form pushed data to klaviyo', item);
          }

        } catch(e) {
          console.error('cdebug error pushing data to klaviyo', e);
        }
      }


      async onProductFormSubmit(e) {
        e.preventDefault();

        // Show the spinner
        this.addToCartSpinner.classList.remove('hidden');
        // disable add to cart button
        this.addToCartButton.setAttribute('aria-disabled', true);
        this.addToCartButton.setAttribute('disabled', true);

        // Gather all information to add the product to cart
        const formData = new FormData(this.productForm);

        const currentSellingPlanDOM = document.querySelector('cart-drawer [data-current-selling-plan]');
        const currentSellingPlan = currentSellingPlanDOM ? currentSellingPlanDOM.getAttribute('data-current-selling-plan') : 'none';
        const defaultSellingPlanId = this.querySelector(`.selling-plan-options`)?.getAttribute('data-default-selling-plan-id');
        const productSellingPlanDOM = this.querySelector(`.selling-plan-options [data-selling-plan-name="${currentSellingPlan}"]`);
        const productSellingPlanId = productSellingPlanDOM ? productSellingPlanDOM.value : defaultSellingPlanId;

        console.log('cdebug currentSellingPlanDOM', currentSellingPlan);

        console.log('cdebug productSellingPlanId', productSellingPlanId);

        // Bundled section rendering - Append to form data sections to be updated after successful add to cart
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);

        // Append to form data line item properties for recharge
        // https://storefront.rechargepayments.com/client/docs/methods/bundle/#getdynamicbundleitems--
        // Rule: Add these information only if product belongs to the dynamic bundle.
        // Drinks and snacks are not included
        if(this.productType == 'meals') {
          // Selling plan is now dynamically added here
          formData.append('selling_plan', productSellingPlanId);
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }

        let response;
        let responseStatus;

        try {
          response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            responseStatus = response.status;

            return response.json();
          });

        } catch (e) {
          console.error('cdebug error', e);
          console.log('cdebug error details', e);
        }

        // If response is 200, then successful request
        if(responseStatus == 200) {

          this.pushDataToKlaviyo();

          // Hide spinner
          this.addToCartSpinner.classList.add('hidden');

          publish(PUB_SUB_EVENTS.cartUpdate,
                    {
                      source: 'cre-product-form',
                      productVariantId: formData.get('id'),
                      incomingQty: 1,
                      sectionUpdates: response.sections
                    })

          // Add to cart always triggers cart update
          // Where the visual response is to show the toast
          // as a sign that add to cart was successful
          this.cart.renderContents(response, true);
        }


        this.addToCartButton.removeAttribute('aria-disabled');
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartSpinner.classList.add('hidden');

      }
    }
  )
}



// Requirements:
// https://storefront.rechargepayments.com/client/docs/examples/bundle/dynamic_price_bundle/#the-dynamic-bundle-properties
